// Map non-ISO currency codes to their parent ISO code for Intl.NumberFormat —
// Intl throws a RangeError on codes like kIDR/mBTC, so they must be mapped.
const currencyToISO: Record<string, string> = {
  kIDR: 'IDR',
  kVND: 'VND',
  kINR: 'INR',
  mBTC: 'BTC',
  mETH: 'ETH',
  mLTC: 'LTC',
  mXRP: 'XRP',
  mTRX: 'TRX',
  mDOGE: 'DOGE',
  mADA: 'ADA',
  mSOL: 'SOL',
  mBNB: 'BNB',
  mTON: 'TON'
}

export interface FormatStatAmountOptions {
  /**
   * Prefix the value with an approximation sign. Stats totals are accumulated
   * USD-normalised and rounded down to whole cents per bet, then converted back
   * to the player currency, so they drift slightly below the exact native
   * amounts in betting history. The sign flags that without any wording.
   */
  approximate?: boolean
}

/** Format a stats amount from minor units (cents) into a display string. */
export const formatStatAmount = (
  amount: number,
  currency: string,
  options?: FormatStatAmountOptions
): string => {
  // Most currencies have 2 decimal places (cents -> dollars)
  const majorUnits = amount / 100
  const isoCurrency = currencyToISO[currency] ?? currency
  const prefix = options?.approximate ? '≈' : ''

  try {
    return `${prefix}${new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: isoCurrency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(majorUnits)}`
  } catch {
    return `${prefix}${currency} ${majorUnits.toFixed(0)}`
  }
}
